export default __webpack_public_path__ + "static/media/discord.87499b4a.svg";